import { apiGet, apiPost, ApiError } from "./client";

export interface CurrentUser {
  id: number;
  first_name: string;
  last_name: string;
  sso_only: boolean;
  email: string;
  last_connection: string;
}

export function getCurrentUser(): Promise<CurrentUser> {
  return apiGet<CurrentUser>("/user");
}

export function changePassword(
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  return apiPost<void>("/change_password", {
    current_password: currentPassword,
    password: newPassword,
  });
}

export { ApiError };
